(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7990],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 59446:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai",
      function () {
        return __webpack_require__(64153);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const FaqCard = (param)=>{
    let { faqQuestion , faqAnswer , questionStyling , answerStyling  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: ()=>setIsOpen(!isOpen),
        className: "px-8 py-7 transition-all duration-300 border border-surface-dark rounded-2xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: faqQuestion
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: faqAnswer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqCard);


/***/ }),

/***/ 64153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ComparisonTable": function() { return /* binding */ ComparisonTable; },
/* harmony export */   "Features": function() { return /* binding */ Features; },
/* harmony export */   "FrustrationFix": function() { return /* binding */ FrustrationFix; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43138);
/* harmony import */ var react_icons_rx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55788);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86585);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10447);









const frustrations = [
    {
        title: "Repetitive Data Entry",
        description: "Filling the same details over and over again."
    },
    {
        title: "Complicated Legal Terms",
        description: "No explanations, just confusing jargon."
    },
    {
        title: "Tedious Template Setup",
        description: "Manually creating forms and templates takes forever."
    },
    {
        title: "Limited Automation & Integrations",
        description: "Struggles to connect with CRMs & workflows."
    }
];
const features = [
    {
        title: "Map My Fields",
        description: "AI automatically detects fields inside documents and places them in the right spots for a seamless and error-free signing experience.",
        image: "map-my-fields.png"
    },
    {
        title: "Intelligent Template Creation",
        description: "Upload any signed contract, and our AI will instantly replace variables, creating a fresh, reusable PDF template ready to send to new signers.",
        image: "intelligent-template-creation.png"
    },
    {
        title: "Dynamic Templates",
        description: "Experience truly intelligent documents that adapt to each signer and situation, automatically customizing content based on context.",
        image: "dynamic-templates.png"
    },
    {
        title: "AI Document Assistant",
        description: "Navigate complex documents with our voice-enabled AI assistant. Get plain-English explanations of complicated terms and conditions as you go.",
        image: "ai-document-assistant.png"
    },
    {
        title: "AI Signature Form Creation",
        description: "Simply describe the form you need in plain English, and our AI will generate it instantly. No more struggling with form builders or starting from scratch.",
        image: "ai-signature-form-creation.png"
    }
];
const PlatformComparison = [
    {
        feature: "Template Generation",
        boloSign: "✅ (Instant AI-powered generation)",
        docuSign: "❌",
        adobeSign: "❌"
    },
    {
        feature: "Smart Auto-Fill",
        boloSign: "✅ (Smart contextual auto-fill)",
        docuSign: "❌",
        adobeSign: "Limited auto-fill"
    },
    {
        feature: "Document Assistant",
        boloSign: "✅ (Interactive AI assistant)",
        docuSign: "❌",
        adobeSign: "❌"
    },
    {
        feature: "Dynamic Templates",
        boloSign: "✅",
        docuSign: "❌",
        adobeSign: "❌"
    },
    {
        feature: "Pricing",
        boloSign: "✅ (AI Included for Free, Affordable Plans)",
        docuSign: "❌ (Expensive, No AI Features)",
        adobeSign: "❌ (Expensive, No AI Features)"
    },
    {
        feature: "AI Signature Form Creation",
        boloSign: "✅ (AI-driven form generation)",
        docuSign: "❌",
        adobeSign: "❌"
    }
];
const Faqs = [
    {
        faqQuestion: "Is BoloSign legally binding?",
        faqAnswer: "Yes, BoloSign complies with e-signature laws and regulations, ensuring your documents are legally binding. We are compliant with all the norms of UETA, ISO, HIPAA, ETA, etc."
    },
    {
        faqQuestion: "How does BoloSign AI make signing documents easier?",
        faqAnswer: "BoloSign AI automates form creation, auto-fills information, explains legal terms, and ensures a seamless signing experience."
    },
    {
        faqQuestion: "Can I migrate from DocuSign, PandaDoc, or Adobe Sign?",
        faqAnswer: "Yes! With one-click AI migration, all your documents, templates, and signer details are transferred instantly."
    },
    {
        faqQuestion: "Do I need technical knowledge to use BoloSign AI?",
        faqAnswer: "Not at all! Our platform is designed to be user-friendly and intuitive, even for first-time users."
    },
    {
        faqQuestion: "Can I create my own contract templates with AI?",
        faqAnswer: "Yes! BoloSign AI can generate templates automatically from any document and adapt them to different signers."
    }
];
// bg gradient 135 deg #2a0e5b to #6120ff
const AI = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "AI Powered eSignatures | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Experience the power of AI in document signing. Faster, smarter, and more intuitive than ever before."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "eSignatures, AI eSignatures, BoloSign, BoloForms, eSignature platform, eSignature solution"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/ai"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "AI Powered eSignatures | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Experience the power of AI in document signing. Faster, smarter, and more intuitive than ever before."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://www.bolosign.com/ai"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/ai"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "AI Powered eSignatures | BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Experience the power of AI in document signing. Faster, smarter, and more intuitive than ever before."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/ai"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "w-full relative pt-8 pb-20 md:py-24 mt-[80px] sm:mt-[98px]",
                style: {
                    background: "linear-gradient(135deg, #2a0e5b, #6120ff)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full max-w-screen-txl mx-auto flex flex-col md:flex-row justify-between items-start gap-8 md:gap-4 lg:gap-20 px-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex-1 flex justify-center flex-col items-center relative z-10 gap-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "text-4xl sm:text-5xl lg:text-7xl font-bold text-white",
                                    children: "The Future of eSignatures is Here"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-lg sm:text-xl lg:text-2xl text-white",
                                    children: "Experience the power of AI in document signing. Faster, smarter, and more intuitive than ever before."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full mt-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "https://signature.boloforms.com/register?from=AI_PAGE".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_7__/* .createUTMQueryParams */ .T0)({
                                            from: "AI_PAGE"
                                        })),
                                        className: "w-fit bg-white text-purple-800 px-10 py-3 rounded-lg text-2xl font-medium",
                                        children: "Get Started"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full sm:w-[400px] lg:w-[40%] relative z-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSETS_URL, "/v2/ai/how-to-use-ai-bolosign.gif"),
                                // src={`${BASE_ASSETS_URL}/ai/how-to-use-ai-bolosign.gif`}
                                className: "w-full h-auto",
                                width: 10,
                                height: 10,
                                loading: "lazy",
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSETS_URL, "/website/assets/v2/ai/headerBg.png"),
                                // src={`${BASE_ASSETS_URL}/ai/headerBg.png`}
                                className: "w-3/4 h-auto xl:w-auto absolute bottom-0 right-0 xl:h-[65%] z-0",
                                width: 200,
                                height: 200,
                                loading: "lazy",
                                alt: ""
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FrustrationFix, {
                data: frustrations
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Features, {
                features: features
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "py-16 sm:py-32",
                style: {
                    background: "linear-gradient(135deg, #2a0e5b, #6120ff)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComparisonTable, {
                    comparisonData: PlatformComparison
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "w-full py-12 md:py-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "p-4 max-w-screen-xl mx-auto w-full flex justify-center flex-col items-center relative z-10 gap-4 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-4xl sm:text-5xl lg:text-6xl font-bold text-black",
                            children: "Currently Using Another eSignature Platform?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-lg max-w-screen-lg mx-auto sm:text-xl lg:text-2xl text-black",
                            children: "Whether you're using DocuSign, PandaDoc, Adobe Sign, or any other platform, switching to BoloSign is seamless. Our AI handles the migration while you enjoy the benefits of a more powerful, affordable solution."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full mt-8 mx-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "https://signature.boloforms.com/register?from=AI_PAGE".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_7__/* .createUTMQueryParams */ .T0)({
                                    from: "AI_PAGE"
                                })),
                                className: "w-fit text-white px-10 py-3 rounded-lg text-2xl font-medium",
                                style: {
                                    background: "linear-gradient(135deg, #552bc2, #ae63ff, #a4bdfe)"
                                },
                                children: "Start Your Migration"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "w-full px-4 py-8 sm:py-12",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-screen-lg mx-auto w-full flex justify-start flex-col items-start gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-4xl sm:text-5xl font-bold text-black mb-2 sm:mb-8",
                            children: "Frequently Asked Question"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full flex flex-col gap-4",
                            children: Faqs.map((faq, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    ...faq
                                }, index))
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AI);
const ComparisonTable = (param)=>{
    let { comparisonData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "max-w-screen-xl mx-auto px-4 text-center flex flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-3xl sm:text-5xl lg:text-6xl font-bold mb-12 text-white",
                children: "Platform Comparison"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overflow-x-auto w-full max-w-screen-xl mx-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                    className: "w-full rounded-2xl bg-white",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                className: "text-center text-base md:text-xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                        className: "px-2 py-4 border-[2px] border-blue-900",
                                        children: "Features"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                        className: "px-2 py-4 border-[2px] border-blue-900",
                                        children: "BoloSign AI"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                        className: "px-2 py-4 border-[2px] border-blue-900",
                                        children: "DocuSign"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                        className: "px-2 py-4 border-[2px] border-blue-900",
                                        children: "Adobe Sign"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                            className: "",
                            children: comparisonData.map((row, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                    className: "text-center text-sm md:text-lg",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                            className: "px-2 py-4 border-[2px] border-blue-900 font-semibold",
                                            children: row.feature
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                            className: "px-2 py-4 border-[2px] border-blue-900",
                                            children: row.boloSign
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                            className: "px-2 py-4 border-[2px] border-blue-900 ",
                                            children: row.docuSign
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                            className: "px-2 py-4 border-[2px] border-blue-900 ",
                                            children: row.adobeSign
                                        })
                                    ]
                                }, index))
                        })
                    ]
                })
            })
        ]
    });
};
const Features = (param)=>{
    let { heading , description , features  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full max-w-screen-mxl mx-auto flex flex-col justify-center items-center gap-8 sm:gap-12 px-4 lg:px-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full max-w-screen-lg mx-auto text-left sm:text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-4xl sm:text-5xl lg:text-6xl font-bold ",
                    children: "Why You'll Love BoloSign AI"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full flex flex-col gap-12 sm:gap-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full flex flex-col gap-16",
                    children: features === null || features === void 0 ? void 0 : features.map((feature, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full flex flex-col justify-between items-center gap-4 sm:gap-20 ".concat(index % 2 === 0 ? "sm:flex-row-reverse" : "sm:flex-row"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full flex flex-col gap-3 sm:gap-6",
                                    children: [
                                        feature.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-2xl sm:text-4xl lg:text-5xl font-semibold md:font-bold",
                                            children: feature.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-lg sm:text-xl lg:text-2xl",
                                            dangerouslySetInnerHTML: {
                                                __html: feature.description
                                            }
                                        })
                                    ]
                                }),
                                feature.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSETS_URL, "/v2/ai/").concat(feature.image),
                                        // src={`${BASE_ASSETS_URL}/v2/gsuite/${feature.image}`}
                                        className: "w-full h-auto",
                                        width: 10,
                                        height: 10,
                                        loading: "lazy",
                                        alt: ""
                                    })
                                })
                            ]
                        }, index))
                })
            })
        ]
    });
};
const FrustrationFix = (param)=>{
    let { data  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "max-w-screen-xl mx-auto px-4 text-center py-16 sm:py-20 flex flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-3xl sm:text-5xl lg:text-6xl font-bold ",
                children: "Why Traditional eSignatures Are Frustrating?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 mt-10 sm:mt-16",
                children: data.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-[#fee5de] px-4 py-6 rounded-md relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-lg h-10 w-10 bg-red-500 rounded-full text-white flex justify-center items-center absolute -top-5 left-1/2 -translate-x-1/2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_rx__WEBPACK_IMPORTED_MODULE_8__/* .RxCross1 */ .ySC, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "font-bold mt-2 text-xl",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg mt-2",
                                children: item.description
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-8 flex justify-center items-center flex-col",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSETS_URL, "/v2/ai/robot.gif"),
                    alt: "AI Robot",
                    className: "w-full h-auto sm:w-auto sm:h-48",
                    width: 200,
                    height: 200,
                    loading: "lazy"
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1057,9774,2888,179], function() { return __webpack_exec__(59446); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);